import { render, staticRenderFns } from "./OptimListItem.vue?vue&type=template&id=00131f99&lang=html&"
import script from "./OptimListItem.vue?vue&type=script&lang=js&"
export * from "./OptimListItem.vue?vue&type=script&lang=js&"
import style0 from "./OptimListItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports